import { useSelector } from "react-redux";
import { AlbumIcon, DollarSignIcon, PersonIcon, ShoppingCartIcon } from "../../../../components/Svgs";
import Kpi from "../Kpi/Kpi";
import classes from "./Kpis.module.css";

const Kpis = ({ kpisData, tenantsData }) => {
  const { orgData } = useSelector((state) => state.orgData);

  const euTenant = tenantsData?.find((tenant) => tenant?.name === "Floodin Ireland");
  const currecny = euTenant?.external_id === orgData?.org?.tenantId ? orgData?.activities?.shopSettings?.currency : "ZAR";

  const kpis = [
    {
      name: "Net revenue",
      value: currecny + " " + kpisData?.revenueGross,
      icon: <DollarSignIcon />,
    },
    {
      name: "Albums created",
      value: kpisData?.albumsCount,
      icon: <AlbumIcon />,
    },
    {
      name: "Sales",
      value: kpisData?.salesCount,
      icon: <ShoppingCartIcon />,
    },
    {
      name: "Guests",
      value: kpisData?.guestsCount,
      icon: <PersonIcon />,
    },
  ];

  return (
    <div className={classes.kpis}>
      {kpis?.map((kpi) => (
        <Kpi kpi={kpi} key={kpi.name} />
      ))}
    </div>
  );
};

export default Kpis;
